export default {
  'dashboardandanalysis.analysis.test': '工专路 {no} 号店',
  'dashboardandanalysis.analysis.introduce': '指标说明',
  'dashboardandanalysis.analysis.total-sales': '总销售额',
  'dashboardandanalysis.analysis.day-sales': '日销售额',
  'dashboardandanalysis.analysis.visits': '访问量',
  'dashboardandanalysis.analysis.visits-trend': '访问量趋势',
  'dashboardandanalysis.analysis.visits-ranking': '门店访问量排名',
  'dashboardandanalysis.analysis.day-visits': '日访问量',
  'dashboardandanalysis.analysis.week': '周同比',
  'dashboardandanalysis.analysis.day': '日同比',
  'dashboardandanalysis.analysis.payments': '支付笔数',
  'dashboardandanalysis.analysis.conversion-rate': '转化率',
  'dashboardandanalysis.analysis.operational-effect': '运营活动效果',
  'dashboardandanalysis.analysis.sales-trend': '销售趋势',
  'dashboardandanalysis.analysis.sales-ranking': '门店销售额排名',
  'dashboardandanalysis.analysis.all-year': '全年',
  'dashboardandanalysis.analysis.all-month': '本月',
  'dashboardandanalysis.analysis.all-week': '本周',
  'dashboardandanalysis.analysis.all-day': '今日',
  'dashboardandanalysis.analysis.search-users': '搜索用户数',
  'dashboardandanalysis.analysis.per-capita-search': '人均搜索次数',
  'dashboardandanalysis.analysis.online-top-search': '线上热门搜索',
  'dashboardandanalysis.analysis.the-proportion-of-sales': '销售额类别占比',
  'dashboardandanalysis.channel.all': '全部渠道',
  'dashboardandanalysis.channel.online': '线上',
  'dashboardandanalysis.channel.stores': '门店',
  'dashboardandanalysis.analysis.sales': '销售额',
  'dashboardandanalysis.analysis.traffic': '客流量',
  'dashboardandanalysis.table.rank': '排名',
  'dashboardandanalysis.table.search-keyword': '搜索关键词',
  'dashboardandanalysis.table.users': '用户数',
  'dashboardandanalysis.table.weekly-range': '周涨幅',
};
